import { OrderedList } from '@tink/core/src/components/atoms/OrderedList/OrderedList';
import { css, styled } from '../../theme/styled';

type Props = {
  size?: 'normal' | 'small';
};

export const OrderedBulletList = styled(OrderedList)<Props>`
  font-size: ${({ theme, size }) => theme.sizes[size || 'normal']};
  color: ${(props) => props.theme.configuration.primaryTextColor};

  &:first-child {
    margin-top: 0;
  }

  & li:before {
    color: ${(props) => props.theme.configuration.primaryColor};
    background-color: ${(props) => props.theme.configuration.tintedBackgroundColor};
  }

  ${({ theme, size = 'normal' }) =>
    size === 'normal'
      ? css`
          li:before {
            font-size: ${theme.sizes.small};
          }
        `
      : css`
          li:before {
            font-size: ${theme.sizes.xsmall};
            top: 0.375rem;
          }
        `}
`;
